var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { get, onChildAdded, onChildChanged, onChildRemoved, onDisconnect, onValue, ref, remove, runTransaction, set, update } from "firebase/database";
export class BrowserFirebaseWrapper {
    constructor(database) {
        this.database = database;
    }
    onValue(path, callback) {
        return onValue(ref(this.database, path), callback);
    }
    onChildAdded(path, callback) {
        return onChildAdded(ref(this.database, path), callback);
    }
    onChildChanged(path, callback) {
        return onChildChanged(ref(this.database, path), callback);
    }
    onChildRemoved(path, callback) {
        return onChildRemoved(ref(this.database, path), callback);
    }
    set(path, value) {
        return set(ref(this.database, path), value);
    }
    get(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return get(ref(this.database, path));
        });
    }
    onDisconnect(path) {
        return onDisconnect(ref(this.database, path));
    }
    remove(path) {
        return remove(ref(this.database, path));
    }
    runTransaction(path, transactionUpdate, options) {
        return runTransaction(ref(this.database, path), transactionUpdate, options);
    }
    update(path, values) {
        return update(ref(this.database, path), values);
    }
}
//# sourceMappingURL=BrowserFirebaseWrapper.js.map